import App from "@codeArt/apps/app";
import lazy from "@codeArt/apps/lazy";
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import StarIcon from '@material-ui/icons/Star';

export function getMenus(baseUrl,{platformEN}) {
    if (baseUrl.endsWith("/")) baseUrl = baseUrl.substr(0, baseUrl.length - 1);

    return [
        {
            name: "用户授权",
            icon: <PeopleAltIcon />,
            auth: { role: "sa" },
            type: "item",
            link: `${baseUrl}/auth/user/index/${App.getParamsCode({ platformEN })}`
        },
        {
            name: "角色管理",
            icon: <StarIcon />,
            auth: { role: "sa" },
            type: "item",
            link: `${baseUrl}/auth/role/index/${App.getParamsCode({ platformEN })}`
        }
    ];
}
export function getRoutes(baseUrl) {
    if (baseUrl.endsWith("/")) baseUrl = baseUrl.substr(0, baseUrl.length - 1);

    return [
        {
            path: `${baseUrl}/auth/role/index/:params`,
            component: lazy(() => import("@codeArt/apps/page/tenant/auth/role/index"))
        },
        {
            path: `${baseUrl}/auth/user/index/:params`,
            component: lazy(() => import("@codeArt/apps/page/tenant/auth/user/index"))
        }
    ]
}